import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { View, Text, Image } from 'react-native';
import styled from 'styled-components/native';
import { color } from '@/constant/color';
import { SccPressable } from '@/components/SccPressable';
export default function BbucleRoadCard({ data, upcomingData, onPress, isDesktop, }) {
    // 공개 예정 카드
    if (upcomingData) {
        return (_jsx(SccPressable, { elementName: "bbucle-road-upcoming-card", trackView: true, logParams: { type: 'upcoming', upcomingId: upcomingData.id }, onPress: onPress, children: _jsxs(UpcomingCardContainer, { isDesktop: isDesktop, children: [_jsxs(UpcomingThumbnailWrapper, { isDesktop: isDesktop, children: [_jsx(UpcomingOverlay, {}), _jsx(UpcomingBadge, { isDesktop: isDesktop, children: _jsx(UpcomingBadgeText, { isDesktop: isDesktop, children: upcomingData.badgeText || (isDesktop ? '알림신청 🔔' : '🔔') }) })] }), _jsxs(ContentWrapper, { isDesktop: isDesktop, children: [_jsx(UpcomingTitle, { isDesktop: isDesktop, children: upcomingData.title }), _jsx(UpcomingSubtitle, { isDesktop: isDesktop, children: upcomingData.subtitle })] })] }) }));
    }
    // 일반 카드
    if (!data)
        return null;
    // 썸네일 이미지 우선순위: ogImageUrl > headerBackgroundImageUrl > titleImageUrl
    const thumbnailUrl = data.ogImageUrl || data.headerBackgroundImageUrl || data.titleImageUrl;
    return (_jsx(SccPressable, { elementName: "bbucle-road-card", trackView: true, logParams: {
            bbucleRoadId: data.id,
            title: data.title,
        }, onPress: onPress, children: _jsxs(CardContainer, { isDesktop: isDesktop, children: [_jsx(ThumbnailWrapper, { isDesktop: isDesktop, children: thumbnailUrl ? (_jsx(ThumbnailImage, { source: { uri: thumbnailUrl }, resizeMode: "cover" })) : (_jsx(ThumbnailPlaceholder, {})) }), _jsxs(ContentWrapper, { isDesktop: isDesktop, children: [_jsx(CardTitle, { isDesktop: isDesktop, numberOfLines: 2, children: data.title }), data.lastUpdatedDate && (_jsx(CardDate, { isDesktop: isDesktop, children: data.lastUpdatedDate }))] })] }) }));
}
const CardContainer = styled(View) `
  flex-direction: row;
  background-color: ${color.white};
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid ${color.gray20};
`;
const UpcomingCardContainer = styled(View) `
  flex-direction: row;
  background-color: ${color.gray10};
  border-radius: 12px;
  overflow: hidden;
  border: 1px dashed ${color.gray30};
`;
const ThumbnailWrapper = styled(View) `
  width: ${({ isDesktop }) => (isDesktop ? '280px' : '120px')};
  height: ${({ isDesktop }) => (isDesktop ? '180px' : '77px')};
  background-color: ${color.gray10};
`;
const UpcomingThumbnailWrapper = styled(View) `
  width: ${({ isDesktop }) => (isDesktop ? '280px' : '120px')};
  height: ${({ isDesktop }) => (isDesktop ? '180px' : '77px')};
  background-color: ${color.gray20};
  justify-content: center;
  align-items: center;
  position: relative;
`;
const UpcomingOverlay = styled(View) `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${color.gray25};
`;
const UpcomingBadge = styled(View) `
  background-color: ${({ isDesktop }) => (isDesktop ? color.brand30 : 'transparent')};
  padding: ${({ isDesktop }) => (isDesktop ? '6px 14px' : '0')};
  border-radius: ${({ isDesktop }) => (isDesktop ? '32px' : '0')};
  z-index: 1;
`;
const UpcomingBadgeText = styled(Text) `
  font-size: ${({ isDesktop }) => (isDesktop ? '16px' : '24px')};
  font-weight: 600;
  color: ${color.white};
  line-height: ${({ isDesktop }) => (isDesktop ? '24px' : '28px')};
`;
const ThumbnailImage = styled(Image) `
  width: 100%;
  height: 100%;
`;
const ThumbnailPlaceholder = styled(View) `
  width: 100%;
  height: 100%;
  background-color: ${color.gray15};
`;
const ContentWrapper = styled(View) `
  flex: 1;
  padding: ${({ isDesktop }) => (isDesktop ? '24px' : '12px')};
  justify-content: center;
`;
const CardTitle = styled(Text) `
  font-size: ${({ isDesktop }) => (isDesktop ? '20px' : '14px')};
  font-weight: 700;
  color: ${color.gray80};
  line-height: ${({ isDesktop }) => (isDesktop ? '28px' : '20px')};
  margin-bottom: ${({ isDesktop }) => (isDesktop ? '8px' : '4px')};
`;
const UpcomingTitle = styled(Text) `
  font-size: ${({ isDesktop }) => (isDesktop ? '20px' : '14px')};
  font-weight: 700;
  color: ${color.gray60};
  line-height: ${({ isDesktop }) => (isDesktop ? '28px' : '20px')};
  margin-bottom: ${({ isDesktop }) => (isDesktop ? '8px' : '4px')};
`;
const UpcomingSubtitle = styled(Text) `
  font-size: ${({ isDesktop }) => (isDesktop ? '14px' : '12px')};
  color: ${color.gray50};
`;
const CardDate = styled(Text) `
  font-size: ${({ isDesktop }) => (isDesktop ? '14px' : '11px')};
  color: ${color.gray50};
`;
